import React, { useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
// Context
// import useCallPerformanceContext from '../context/useCallPerformanceContext';

/* eslint-disable react/prop-types */
export default function CallPerformanceTable({ height, loading, data = [], name }) {
  let tableColumn;
  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  if (name === 'nsm' || name === 'rsm') {
    tableColumn = [
      {
        field: name === 'nsm' ? 'nsm_name' : 'rsm_name',
        headerName: name === 'nsm' ? 'NSM Name' : 'RSM name',
        width: 200,
        flex: 1,
        headerClassName: 'super-app-theme--header',
      },
      {
        field: 'managers',
        headerName: 'Manager',
        width: 200,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        renderCell: ({ row }) =>
          Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.managers),
      },
      {
        field: 'mpr',
        headerName: 'MPR',
        width: 200,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        renderCell: ({ row }) =>
          Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.mpr),
      },
    ];
  } else {
    tableColumn = [
      {
        field: `rsm_name`,
        headerName: `RSM Name`,
        width: 200,
        flex: 1,
        headerClassName: 'super-app-theme--header',
        renderCell: ({ row }) => (row.nsm_name === 'TOTAL' ? 'Total' : row.rsm_name),
      },
      {
        field: `manager_name`,
        headerName: `Manager Name`,
        width: 200,
        flex: 1,
        headerClassName: 'super-app-theme--header',
      },
      {
        field: `mpr_name`,
        headerName: `MPR Name`,
        width: 200,
        flex: 1,
        headerClassName: 'super-app-theme--header',
      },
    ];
  }

  const columns = [
    ...tableColumn,

    {
      field: 'md',
      headerName: 'MD',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.md),
    },
    {
      field: 'plotted',
      headerName: 'Plotted',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.plotted),
    },
    {
      field: 'actual',
      headerName: 'Actual',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.actual),
    },
    {
      field: 'performance',
      headerName: 'Performance',
      width: 200,
      flex: 1,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) => `${parseFloat(row.performance).toFixed(2)}%`,
    },
  ];
  const pinnedRows = {
    top: data?.length ? [data[0]] : [],
  };
  return (
    <div>
      <Box
        className='table-container'
        sx={{
          height: `${height}px`,
          '& .super-app-theme--header': {
            fontWeight: 'bold',
            backgroundColor: '#808080',
            color: '#fff',
          },
          '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#FBCEB1' },
        }}
      >
        <DataGridPro
          loading={loading}
          rows={data}
          columns={columns}
          sortModel={sortModel}
          pinnedRows={pinnedRows}
          experimentalFeatures={{ rowPinning: true }}
          initialState={{
            ...data.initialState,
            pagination: {
              pageSize: 50,
            },
          }}
          rowsPerPageOptions={[10, 25, 50]}
          pagination
          onSortModelChange={(model) => setSortModel(model)}
        />
      </Box>
    </div>
  );
}
